import React from 'react'
import { RiDownloadLine } from "react-icons/ri";

const DownloadButton = ({ onClick }) => {
    return (
        <button
            onClick={onClick}
            className="flex gap-2 items-center justify-center hover:bg-[#fab700] hover:text-[#fff] text-[#6B7280] transition-all delay-200 duration-200 ease-in border border-[#fab700b0] rounded-full h-10 w-[130px]">
            <RiDownloadLine size={17} />
            Get app
        </button>
    )
}

export default DownloadButton